export function verificarIdade(dataSelecionada: Date): boolean {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const dataMinima = new Date(
        hoje.getFullYear() - 18,
        hoje.getMonth(),
        hoje.getDate()
    );
    dataMinima.setHours(23, 59, 59, 999); // Permite o dia completo de 18 anos atrás

    // Normaliza a data selecionada para comparação precisa
    const dataNormalizada = new Date(dataSelecionada);
    dataNormalizada.setHours(0, 0, 0, 0);

    return dataNormalizada <= dataMinima;
}